import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import { getApiUrl } from '../../helpers/helperApp';

function PendienteFirmaModalContent({ confPantalla, loading, onCancel, cicloId, apiKeyFn }) {
    const title = confPantalla?.runciccfg?.padre?.helpmodal?.title || 'FIRMAR PEDIDO';
    const cancelText = confPantalla?.runciccfg?.padre?.btncancelar?.title || 'Cancelar';
    const goToSignaturesText = 'Ver firmas';
    const [loadingSigns, saveLoadingSigns] = useState(false);
    const [signsError, saveSignsError] = useState("");
    const [signGroups, saveSignGroups] = useState([]);

    const signers = Array.isArray(signGroups[0]) ? signGroups[0] : [];
    const groupInfo = signGroups[1] && typeof signGroups[1] === 'object' && !Array.isArray(signGroups[1]) ? signGroups[1] : null;
    const groupAgentsCount = groupInfo && Object.prototype.hasOwnProperty.call(groupInfo, 'nAgents')
        ? Number(groupInfo.nAgents)
        : null;
    const hasGroupAgentsCount = Number.isFinite(groupAgentsCount);
    const groupAgentTypeLabel = groupInfo?.agentTypeInfo?.label || '';

    const params = new URLSearchParams({ cicloId: String(cicloId) });

    useEffect(() => {
        if (!cicloId || !apiKeyFn) return;
        let isMounted = true;

        const fetchSigns = async () => {
            try {
                saveLoadingSigns(true);
                saveSignsError("");
                const data = new FormData();
                data.append("validacion", apiKeyFn());
                data.append("cicCfgId", cicloId);
                const response = await axios.post(getApiUrl(window.location.origin) + "/Signs/getSignsDocument", data);
                if (!isMounted) return;
                if (response.data?.data) {
                    const normalizedSigns = Array.isArray(response.data?.data) ? response.data.data : [];
                    saveSignGroups(normalizedSigns);
                } else {
                    saveSignGroups([]);
                    saveSignsError(response.data?.message || "No se pudieron obtener las firmas.");
                }
            } catch (error) {
                if (!isMounted) return;
                saveSignGroups([]);
                saveSignsError("Error consultando firmas del documento.");
            } finally {
                if (isMounted) saveLoadingSigns(false);
            }
        };

        fetchSigns();
        return () => {
            isMounted = false;
        };
    }, [cicloId, apiKeyFn]);


    return (
        <>
            <Modal.Header closeButton>
                <h5 className="mb-0">{title}</h5>
            </Modal.Header>
            <Modal.Body>
                {loadingSigns ?
                    <div className='mt-2 mb-2' style={{ textAlign: "center" }}>
                        <Spinner animation="border" />
                    </div>
                :
                    null
                }
                {signsError ? <p className="text-danger mb-0">{signsError}</p> : null}
                {!loadingSigns && !signsError && signers.length === 0 && !hasGroupAgentsCount ? <p className="mb-0">No hay firmas configuradas.</p> : null}
                {!loadingSigns && !signsError && signers.length > 0 ?
                    <div className="card mt-2" key="sign-group-main">
                        <div className="card-header py-2">
                            <strong>Firma 1</strong>
                        </div>
                        <div className="card-body py-2">
                            {signers.map((signer, signerIndex) => {
                                const signerLabel = signer?.label || '-';
                                const signValue = signer?.sign;
                                const hasSign = !!(signValue && String(signValue).trim() !== "");
                                const signSrc = hasSign
                                    ? (String(signValue).startsWith("data:image/")
                                        ? signValue
                                        : `data:image/png;base64,${signValue}`)
                                    : null;
                                const signerName = signer?.sign_name && String(signer.sign_name).trim() !== '' ? signer.sign_name : 'Sin nombre de firma configurado';
                                const signerPosition = signer?.sign_position && String(signer.sign_position).trim() !== '' ? signer.sign_position : 'Sin cargo configurado';
                                return (
                                    <div className="col-12 d-flex align-items-center justify-content-between" key={`signer-row-${signerIndex}`}>
                                        <span>
                                            <strong>{signerLabel}</strong> - {signerName} - {signerPosition}
                                        </span>
                                        {hasSign ? (
                                            <img
                                                src={signSrc}
                                                alt={`Firma ${signerLabel}`}
                                                style={{ maxHeight: 42, maxWidth: 180, objectFit: "contain" }}
                                            />
                                        ) : (
                                            <span className="text-muted">Sin firma configurada</span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                : null}
                {!loadingSigns && !signsError && hasGroupAgentsCount ?
                    <div className="card mt-2" key="sign-group-agents-count">
                        <div className="card-header py-2">
                            <strong>Firma 2</strong>
                        </div>
                        <div className="card-body py-2">
                            <p className="mb-0">
                                Pueden firmar {groupAgentsCount} personas{groupAgentTypeLabel ? ` del grupo ${groupAgentTypeLabel}` : ''}.
                            </p>
                        </div>
                    </div>
                : null}
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-flat btn-primary"
                    onClick={() => { window.open(`/signatures?${params.toString()}`, '_blank', 'noopener,noreferrer'); }}
                    disabled={loading}
                >
                    {goToSignaturesText}
                </button>
                <button type="button" className="btn btn-flat btn-danger" onClick={onCancel} disabled={loading}>
                    {cancelText}
                </button>
            </Modal.Footer>
        </>
    );
}

export default PendienteFirmaModalContent;
